import React from "react";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { updateEmployeeDetails } from "../Auth/action";
import { EMPLOYEES_API } from "../constants/urlConstants";
import { utilities } from "../components/utilities";

const ConfirmDelete = ({ employee, show, onHide }) => {
  const dispatch = useDispatch();
  const employeeList = useSelector((s) => s.EmployeeListReducer.employeeList);

  const deleteUser = () => {
    axios
      .delete(`${EMPLOYEES_API}/deleteuser`, { data: { employee_id: employee.employee_id } })
      .then(() => {
        const newList = employeeList.filter(
          (e) => e.employee_id.toUpperCase() !== employee.employee_id.toUpperCase()
        );
        dispatch(updateEmployeeDetails(newList));
        utilities.showToast("User Deleted Successfully");
        onHide();
      })
      .catch(() => utilities.showToast("Couldn't Delete User!", true));
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton><Modal.Title>Delete Employee</Modal.Title></Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to delete {employee?.employee_name} (ID: {employee?.employee_id})?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancel</Button>
        <Button variant="primary" onClick={deleteUser}>Delete</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDelete;
